"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("swiper/react");
var _swiper = require("swiper");
const _excluded = ["settings", "children", "keys", "buttons", "buttonStyle"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const settings = {
  dots: "false",
  infinite: "false",
  speed: 500,
  navigation: true
};

// const SlickArrowLeft = ({ currentSlide, slideCount, content, ...props }) => (
//     <button
//         {...props}
//         className={
//             "slick-prev slick-arrow" +
//             (currentSlide === 0 ? " slick-disabled" : "")
//         }
//         aria-hidden="true"
//         aria-disabled={currentSlide === 0}
//         type="button"
//     >
//         {content}
//     </button>
// );
// const SlickArrowRight = ({ currentSlide, slideCount, content, ...props }) => (
//     <button
//         {...props}
//         className={
//             "slick-next slick-arrow" +
//             (currentSlide === slideCount - 1 ? " slick-disabled" : "")
//         }
//         aria-hidden="true"
//         aria-disabled={currentSlide === slideCount - 1}
//         type="button"
//     >
//         {content}
//     </button>
// );

/**
 *
 * @method Slider
 *
 * @param {Object} settings
 * @param children
 * @param {Array} keys
 * @param {Object} buttons - content for prev/next buttons
 * @param {Object} buttonStyle - styles for prev/next buttons
 * @return {JSX.Element}
 * @constructor
 */
const Slider = _ref => {
  let {
      settings: propSettings = {},
      children,
      keys = [],
      buttons = {
        left: 'Prev',
        right: 'Next'
      },
      buttonStyle = {
        left: {},
        right: {}
      }
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const prevRef = (0, _react.useRef)(null);
  const nextRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement(_react2.Swiper, _extends({}, settings, propSettings, {
    // prevArrow={<SlickArrowLeft content={buttons.left}/>}
    // nextArrow={<SlickArrowRight content={buttons.right}/>}
    modules: [_swiper.Navigation],
    className: "DefaultSlider ".concat(props.className || ''),
    style: props.style || {},
    onInit: swiper => {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }), children.map((child, i) => /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
    key: keys[i]
  }, child)), /*#__PURE__*/_react.default.createElement("div", {
    className: 'swiper-button-prev swiper-button-disabled',
    ref: prevRef,
    style: buttonStyle.left || {}
  }, buttons.left), /*#__PURE__*/_react.default.createElement("div", {
    className: 'swiper-button-next swiper-button-disabled',
    ref: nextRef,
    style: buttonStyle.right || {}
  }, buttons.right));
};
var _default = exports.default = Slider;